import { createContext, useContext, useEffect, useState } from "react";
// import { tockenExchange } from "./authService";
import { useSelector } from "react-redux";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [webToken, setWebToken] = useState(localStorage.getItem("webToken"));
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const userData = JSON.parse(localStorage.getItem('user') || '{}');
  const userData11 = useSelector((state) => state.user.user);
  console.log(userData,"userDatauserData111",userData11)

  const login = async (newToken) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setIsAuthenticated(true);
    // tockenExchange(newToken)
    //   .then(async (webTokenResponse) => {
    //     console.log("Web token response:", webTokenResponse,webTokenResponse?.ok);
    //     if (webTokenResponse?.webToken) {
    //       const newWebToken = webTokenResponse.webToken;
    //       localStorage.setItem("webToken", newWebToken);
    //       setWebToken(newWebToken);
    //     }
    //   })
    //   .catch((webTokenError) => {
    //     console.error("Error getting web token:", webTokenError);
    //   });
    // try {
    //     const webTokenResponse = await fetch(`${API_BASE_URL}/token-exchange?Authorization=Bearer ${newToken}`, {
    //         method: 'POST',
    //         headers: {
    //             'accept': '*/*',
    //             'Authorization': `Bearer ${newToken}`
    //         }
    //     });

    //     if (webTokenResponse.ok) {
    //         const webTokenData = await webTokenResponse.json();
    //         const newWebToken = webTokenData.webToken;
    //         localStorage.setItem('webToken', newWebToken);
    //         setWebToken(newWebToken);
    //     }
    // } catch (error) {
    //     console.error('Error getting web token:', error);
    // }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("webToken");
    setToken(null);
    setWebToken(null);
    setIsAuthenticated(false);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedWebToken = localStorage.getItem("webToken");
    if (storedToken) {
      setToken(storedToken);
      setIsAuthenticated(true);
    }
    if (storedWebToken) {
      setWebToken(storedWebToken);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token,
        webToken,
        isAuthenticated,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
